import React, { type ReactNode } from 'react';
import { Flex, Spin } from 'antd';
import { useDownloadContext } from '../contexts/global-download-context-provider';
const contentStyle: React.CSSProperties = {
  padding: 50,
  borderRadius: 4,
};

const content = <div style={contentStyle} />;
const GlobalDownloadIndicator = (): ReactNode => {
  const { isDownloading } = useDownloadContext();
  return (
    isDownloading && (
      <Flex
        style={{
          position: 'fixed',
          bottom: 50,
          right: 50,
        }}
      >
        <Spin tip="Downloading Menu" size="large">
          {content}
        </Spin>
      </Flex>
    )
  );
};

export default GlobalDownloadIndicator;
